import { render, staticRenderFns } from "./NftCard.vue?vue&type=template&id=63109f91&scoped=true&"
import script from "./NftCard.vue?vue&type=script&lang=ts&"
export * from "./NftCard.vue?vue&type=script&lang=ts&"
import style0 from "./NftCard.vue?vue&type=style&index=0&id=63109f91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63109f91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
